export default "__VITE_ASSET__UrFDK$iJ__"